import React from 'react';
import './Hero.styles.scss';
import { HeroProps } from './Hero.logic';
import Button from '../Button/Button'; // Assuming a Button component exists

interface ExtendedHeroProps extends Omit<HeroProps, 'attachment'> {
  backgroundImg?: string; // Optional path to the background image
  btnURL?: string; // Optional URL for the button
  btnLabel?: string; // Optional label for the button
  btnBgColor?: string; // Optional background color for the button
}

const Hero: React.FC<ExtendedHeroProps> = ({
  helper,
  headline,
  id,
  type,
  children,
  backgroundImg,
  btnURL,
  btnLabel,
  btnBgColor,
}) => {
  return (
    <div
      className={`hero-container ${type ? `hero-type-${type}` : ''}`}
      id={id}
      style={{
        backgroundImage: backgroundImg ? `url(${backgroundImg})` : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: backgroundImg ? '100vh' : 'unset',
      }}
    >
      <div className={`hero-wrapper ${backgroundImg && 'with-img'}`}>
        {helper && (
          <p className="helper action-on-view action-fade-in">{helper}</p>
        )}
        {headline && (
          <h1
            className="headline action-on-view action-fade-in action-delay-250"
            dangerouslySetInnerHTML={{ __html: headline }}
          ></h1>
        )}
        {children && <div className="hero-attachment">{children}</div>}
        {btnURL && btnLabel && (
          <div className="hero-attachment">
            <Button
              url={btnURL}
              backgroundColor={btnBgColor}
              label={btnLabel}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Hero;
